const EN_ONES = [
  '',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
];

const EN_TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

const TE_ONES = [
  '',
  'ఒకటి',
  'రెండు',
  'మూడు',
  'నాలుగు',
  'ఐదు',
  'ఆరు',
  'ఏడు',
  'ఎనిమిది',
  'తొమ్మిది',
  'పది',
  'పదకొండు',
  'పన్నెండు',
  'పదమూడు',
  'పద్నాలుగు',
  'పదిహేను',
  'పదహారు',
  'పదిహేడు',
  'పద్దెనిమిది',
  'పంతొమ్మిది',
];

const TE_TENS = ['', '', 'ఇరవై', 'ముప్పై', 'నలభై', 'యాభై', 'అరవై', 'డెబ్బై', 'ఎనభై', 'తొంభై'];

const toWholeNumber = (value) => {
  const numeric = typeof value === 'number' ? value : Number(String(value || '').replace(/,/g, ''));
  return Number.isFinite(numeric) ? Math.round(numeric) : 0;
};

const sentenceCase = (text) => {
  if (!text) return text;
  return text[0].toUpperCase() + text.slice(1);
};

const underThousandToEnglishWords = (value) => {
  let num = Math.max(0, Math.floor(value));
  if (num === 0) return '';

  const parts = [];
  const hundreds = Math.floor(num / 100);
  num %= 100;

  if (hundreds > 0) {
    parts.push(`${EN_ONES[hundreds]} hundred`);
  }

  if (num > 0) {
    if (num < 20) {
      parts.push(EN_ONES[num]);
    } else {
      const tens = Math.floor(num / 10);
      const ones = num % 10;
      parts.push(ones ? `${EN_TENS[tens]} ${EN_ONES[ones]}` : EN_TENS[tens]);
    }
  }

  return parts.join(' ').trim();
};

const underHundredToTeluguWords = (value) => {
  const num = Math.max(0, Math.floor(value));
  if (num === 0) return '';
  if (num < 20) return TE_ONES[num];

  const tens = Math.floor(num / 10);
  const ones = num % 10;
  return ones ? `${TE_TENS[tens]} ${TE_ONES[ones]}` : TE_TENS[tens];
};

const underThousandToTeluguWords = (value) => {
  let num = Math.max(0, Math.floor(value));
  if (num === 0) return '';

  const hundreds = Math.floor(num / 100);
  num %= 100;
  const parts = [];

  if (hundreds > 0) {
    if (hundreds === 1 && num === 0) {
      parts.push('వంద');
    } else if (hundreds === 1) {
      parts.push('నూట');
    } else {
      parts.push(`${TE_ONES[hundreds]} వందల`);
    }
  }

  if (num > 0) {
    parts.push(underHundredToTeluguWords(num));
  }

  return parts.join(' ').trim();
};

const appendIndianUnit = (parts, value, singularLabel, pluralLabel, formatter, singularWord = '') => {
  if (value <= 0) return;
  if (value === 1 && singularWord) {
    parts.push(singularWord);
    return;
  }
  if (value === 1 && singularLabel) {
    parts.push(`${formatter(value)} ${singularLabel}`.trim());
    return;
  }
  parts.push(`${formatter(value)} ${pluralLabel}`.trim());
};

const formatEnglishCurrencyWords = (amount) => {
  const rounded = toWholeNumber(amount);
  const absoluteRounded = Math.abs(rounded);
  if (absoluteRounded === 0) return 'Zero rupees only';

  let value = absoluteRounded;
  const parts = [];

  const crore = Math.floor(value / 10000000);
  value %= 10000000;

  const lakh = Math.floor(value / 100000);
  value %= 100000;

  const thousand = Math.floor(value / 1000);
  value %= 1000;

  if (crore > 0) parts.push(`${underThousandToEnglishWords(crore)} crore`);
  if (lakh > 0) parts.push(`${underThousandToEnglishWords(lakh)} lakh`);
  if (thousand > 0) parts.push(`${underThousandToEnglishWords(thousand)} thousand`);
  if (value > 0) parts.push(underThousandToEnglishWords(value));

  const baseWords = sentenceCase(parts.join(' ').trim());
  return `${baseWords} rupees only`;
};

const formatTeluguCurrencyWords = (amount) => {
  const rounded = toWholeNumber(amount);
  const absoluteRounded = Math.abs(rounded);
  if (absoluteRounded === 0) return 'సున్నా రూపాయలు మాత్రమే';

  let value = absoluteRounded;
  const parts = [];

  const crore = Math.floor(value / 10000000);
  value %= 10000000;

  const lakh = Math.floor(value / 100000);
  value %= 100000;

  const thousand = Math.floor(value / 1000);
  value %= 1000;

  appendIndianUnit(parts, crore, 'కోటి', 'కోట్లు', underThousandToTeluguWords);
  appendIndianUnit(parts, lakh, 'లక్ష', 'లక్షలు', underThousandToTeluguWords);
  appendIndianUnit(parts, thousand, '', 'వేల', underThousandToTeluguWords, 'వెయ్యి');
  if (value > 0) {
    parts.push(underThousandToTeluguWords(value));
  }

  return `${parts.join(' ').trim()} రూపాయలు మాత్రమే`;
};

import { getLanguageConfig } from '../i18n/translations';

export const formatIndianCurrencyWords = (amount, language = 'en') => {
  const langConfig = getLanguageConfig(language);
  // Use language-specific formatter based on code
  switch (langConfig.code) {
    case 'te':
      return formatTeluguCurrencyWords(amount);
    case 'en':
    default:
      return formatEnglishCurrencyWords(amount);
  }
};

export default formatIndianCurrencyWords;
